import { z } from 'zod';

/**
 * A string that must be present and not empty, reporting `message` for both -
 * as yup's `.required(message)` did, which treated '' as missing.
 */
export const requiredString = (message: string) =>
  z.string(message).min(1, message);
